import {Stack, styled} from '@mui/material';

export const StyledFooterContainer = styled(Stack)`
	flex-direction: column;
	justify-content: space-between;
`;
